exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbutton[data-v-94cff0ba]{width:75px\n}\ni[data-v-94cff0ba]{width:100%\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/website_dev/src/components/v2/story-edit-view/timeline-components/sounds.vue"],"names":[],"mappings":";AAuIA,wBACE,UAAW;CACZ;AAAA,mBAGC,UAAW;CACZ","file":"sounds.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nbutton {\n  width: 75px;\n}\n\ni {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-94cff0ba","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/v2/story-edit-view/timeline-components/sounds.vue
// module id = 1i8i
// module chunks = 1